/* global App */
import { CollectionResponse } from "active-resource";
import React, { Component, Fragment } from "react";
import { detect } from "detect-browser";
import * as Sentry from "@sentry/react";
import Notification from "../shared/notifications/Notification";
import fetchNotifications from "../shared/notifications/fetchNotifications";
import FullScreenLoading from "../shared/loaders/FullScreenLoading";
import {
  NotificationsWrapper,
  ItemsWrapper,
  Item,
  AboutNotification,
  NotificationLink,
  IconWrapper,
  NotificationIcon,
  BodyWrapper,
  NotificationText,
  Subject,
  Time,
  NoContent,
} from "./styles/notifications-list-data-styles";

class NotificationsList extends Component {
  constructor(props) {
    super(props);
    const notifications = CollectionResponse.build([]);
    this.state = {
      notifications,
      loading: true,
    };
  }

  componentDidMount() {
    this.subscribeChannel();
    fetchNotifications(
      (notificationsCollectionResponse) => {
        this.setState({
          notifications: notificationsCollectionResponse,
          loading: false,
        });
      },
      (error) => {
        Sentry.captureException(error);
      }
    );
  }

  subscribeChannel = () => {
    App.cable.subscriptions.create(
      { channel: "NotificationsChannel" },
      {
        connected: () => {},
        disconnected: () => {},
        received: () => {
          fetchNotifications(
            (notificationsCollectionResponse) => {
              this.setState({
                notifications: notificationsCollectionResponse,
              });
            },
            (error) => {
              Sentry.captureException(error);
            }
          );
        },
      }
    );
  };

  render() {
    const { notifications, loading } = this.state;

    const iOS = detect().name === "ios";

    return (
      <NotificationsWrapper iOS={iOS}>
        {loading ? (
          <FullScreenLoading />
        ) : (
          <Fragment>
            {notifications.empty() && (
              <NoContent>You have no new notifications</NoContent>
            )}
            <ItemsWrapper>
              {notifications.toArray().map((notification) => (
                <Item key={notification.id}>
                  <Notification
                    notification={notification}
                    key={notification.id}
                    AboutNotification={AboutNotification}
                    NotificationLink={NotificationLink}
                    IconWrapper={IconWrapper}
                    NotificationIcon={NotificationIcon}
                    BodyWrapper={BodyWrapper}
                    NotificationText={NotificationText}
                    Subject={Subject}
                    Time={Time}
                  />
                </Item>
              ))}
            </ItemsWrapper>
          </Fragment>
        )}
      </NotificationsWrapper>
    );
  }
}

export default NotificationsList;
